import { DashboardShell } from "./DashboardShell";
import { logisticsPreview } from "@/data/dashboardPreview.data";
import { DashboardContent } from "./DashboardContent";
import { MetricCard } from "./MetricCard";

interface Props {
    accent: string;
}

export function LogisticsDashboard({
    accent,
}: Props) {
    const preview = logisticsPreview;

    return (
        <DashboardShell
            accent={accent}
            title="Logistics Management Platform"
            subtitle="Fleet, shipment and warehouse operations"
            sidebar={[
                "Dashboard",
                "Shipments",
                "Fleet",
                "Drivers",
                "Warehouses",
                "Routes",
                "Invoices",
                "Reports",
            ]}
        >
            <DashboardContent

                accent={accent}

                preview={preview}

                activityTitle="Logistics Activity"

            />
            <div className="mt-6 grid gap-3 md:grid-cols-4">

                {
                    [
                        {
                            label: "Fuel Efficiency",
                            value: "96%",
                            trend: "+4%"
                        },
                        {
                            label: "Warehouse Accuracy",
                            value: "99.4%",
                            trend: "+1%"
                        },
                        {
                            label: "Average Transit",
                            value: "2 Days",
                            trend: "-6%"
                        },
                        {
                            label: "Customer Satisfaction",
                            value: "97%",
                            trend: "+3%"
                        },
                    ].map((metric) => (

                        <MetricCard
                            key={metric.label}
                            accent={accent}
                            label={metric.label}
                            value={metric.value}
                            trend={metric.trend}
                        />

                    ))
                }

            </div>
            {/* <div className="grid gap-6"> */}


                {/* =====================================================
                    Shipment Analytics
                ====================================================== */}

                {/* 

                <div className="grid gap-6 lg:grid-cols-3">

                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Fleet Utilization
                        </h3>

                        <div className="mt-5 space-y-5">

                            {[
                                {
                                    fleet: "North Zone",
                                    value: 91,
                                },
                                {
                                    fleet: "East Zone",
                                    value: 83,
                                },
                                {
                                    fleet: "South Zone",
                                    value: 76,
                                },
                                {
                                    fleet: "West Zone",
                                    value: 88,
                                },
                            ].map((fleet) => (

                                <div key={fleet.fleet}>

                                    <div className="flex justify-between text-sm">

                                        <span>{fleet.fleet}</span>

                                        <span>{fleet.value}%</span>

                                    </div>

                                    <div className="mt-2 h-2 rounded-full bg-muted">

                                        <div
                                            className="h-full rounded-full"
                                            style={{
                                                width: `${fleet.value}%`,
                                                background: accent,
                                            }}
                                        />

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            AI Route Optimizer
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                "Routes Optimized: 42",
                                "Fuel saving: 11.8%",
                                "Traffic congestion avoided on NH-16.",
                                "Avg delivery time reduced by 19 minutes.",
                            ].map((item) => (

                                <div
                                    key={item}
                                    className="rounded-xl border border-border p-4"
                                >

                                    <p className="text-sm">
                                        {item}
                                    </p>

                                </div>

                            ))}

                        </div>

                    </div>

                </div>
                <div className="grid gap-5 md:grid-cols-4">

                    <MetricCard
                        accent={accent}
                        label="Fuel Efficiency"
                        value="96%"
                        trend="+4%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Warehouse Accuracy"
                        value="99.4%"
                        trend="+1%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Average Transit"
                        value="1.8 Days"
                        trend="-6%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Customer Satisfaction"
                        value="97%"
                        trend="+3%"
                    />

                </div> */}

            {/* </div> */}

        </DashboardShell>

    );
}